import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import DateFnsUtils from '@date-io/date-fns';
import { Grid, MenuItem } from '@mui/material';
import { DatePicker, Select } from 'mui-rff';
//
import ButtonSubmit from 'components/common/ButtonSubmit';
import { DEFAULT_DATE_FORMAT } from '../../../constants/reports';
import { PICKER_MIN_DATE } from '../../../constants';
import { filterParamsForm } from 'utils/normalizers';

const FilterPanel = ({ initialValues, applyFilters, clientOptionsData }) => {
  const onSubmit = useCallback(
    (values) => {
      applyFilters(filterParamsForm(values));
    },
    [applyFilters],
  );

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, values, submitting }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid
            container
            alignItems='flex-start'
            spacing={2}
            px='16px'
            mt='15px'
            mb='10px'
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <DatePicker
                name='startDate'
                margin='none'
                label='Start Date'
                minDate={PICKER_MIN_DATE}
                disableFuture
                dateFunsUtils={DateFnsUtils}
                maxDate={values['endDate']}
                format={DEFAULT_DATE_FORMAT}
                inputFormat={DEFAULT_DATE_FORMAT}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <DatePicker
                name='endDate'
                margin='none'
                label='End Date'
                disableFuture
                minDate={values['startDate']}
                dateFunsUtils={DateFnsUtils}
                format={DEFAULT_DATE_FORMAT}
                inputFormat={DEFAULT_DATE_FORMAT}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Select name='wlid' label='WLID' multiple>
                {clientOptionsData.map((item, index) => (
                  <MenuItem value={item.wlid} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <ButtonSubmit
                type='submit'
                name='Apply'
                onSubmit={handleSubmit}
                isPending={submitting}
                style={{ textAlign: 'right' }}
              />
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default FilterPanel;
